module.exports = __webpack_public_path__ + "img/neutral-emoji.afb0e9b1.svg";